import { useEffect, useState } from "react";
import { FaTrash, FaEdit, FaSearch } from "react-icons/fa";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import { ImageFolderEnum, respEnum } from "../../../constants/appConstant";
import {
  AppInput,
  AppSearchSelect,
  AppSelect,
  AppSwitch,
} from "../../../components/appComponents";
import Card from "../../../components/ui/card-snippet";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { ImagePlus, Edit2 } from "lucide-react";
import toast from "react-hot-toast";
import { Input } from "../../../components/ui/input";
import { useRef } from "react";

export default function Teaming() {
  const [tournaments, setTournaments] = useState([]);
  const [tournamentId, setTournamentId] = useState(null);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
  const [tournament, setTournament] = useState({
    id: null,
    name: "",
    noofplayers: 2,
    maxTeams: 0,
  });
  const [teams, setTeams] = useState([]);
  const [currentTeam, setCurrentTeam] = useState({
    id: null,
    teamName: "",
    isqualify: false,
    logo: null,
    is_join_from_app: false,
    group: "",
    players: [],
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [noOfPlayers, setNoOfPlayers] = useState(2);
  const [playerFields, setPlayerFields] = useState([]);
  const [isDropdownEnabled, setIsDropdownEnabled] = useState(false);
  const [record, setRecord] = useState(false);

  const fileInputRef = useRef();
  useEffect(() => {
    // Initialize with default player fields
    updatePlayerFields(noOfPlayers);
    getTournaments();
  }, []);

  useEffect(() => {
    if (tournamentId) {
      getTournamentTeamDetails(tournamentId);
    }
  }, [tournamentId]);

  useEffect(() => {
    updatePlayerFields(noOfPlayers);
  }, [noOfPlayers]);

  const updatePlayerFields = (count) => {
    const fields = [];
    for (let i = 0; i < count; i++) {
      fields.push({
        index: i,
        playerId: null,
        firstName: "",
        lastName: "",
        phone: "",
      });
    }
    setPlayerFields(fields);
  };

  const getTournaments = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetTournamentDDL"
    );
    if (response?.data) {
      console.log("Tournament data:", response.data);
      setTournaments([
        { id: null, name: "Select Tournament" },
        ...response.data,
      ]);
    }
  };

  const getTournamentTeamDetails = async (id) => {

    if (!id) return;

    
    const response = await Common.ApiService.getInstance().request(
      `GetTournamentTeamDetails?tournamentId=${id}`
    );
    if (response?.data) {
      setTeams(response.data);
    }else
    {
      setTeams([])
    }

  };



  const checkUserExist = async (phone, index) => {
    // if (!phone || phone.length < 10) return;
    try {
    const response = await Common.ApiService.getInstance().request(
      `CheckUserExistForTeaming?phone=${phone}`
    );
    const updatedFields = [...playerFields];
    if (response.status === respEnum.Success) {
      const user = response.data;
      updatedFields[index] = {
        ...updatedFields[index],
        playerId: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        phone: user.phone,
      };
    }
    else{
      updatedFields[index] = {
        ...updatedFields[index],
        playerId: null,
        firstName: null,
        lastName: null,
      }
    } 
    setPlayerFields(updatedFields);

    } catch (error) {
      Common.showToast(error && "Please Enter Correct Number", "Error");
    }
  };

  const changeTournament = (val) => {
    setTournamentId(val);
    setIsDropdownEnabled(val !== null);
    setTeams([]);

    const selectedTournament = tournaments.find((t) => t.id === val);
    if (selectedTournament) {
      console.log("Selected tournament:", selectedTournament);
      setTournament({
        id: selectedTournament.id,
        name: selectedTournament.name,
        noofplayers: selectedTournament.noofplayers || 2,
        maxTeams: selectedTournament.maxTeams || 0,
      });

      setNoOfPlayers(selectedTournament.noofplayers || 2);
      updatePlayerFields(selectedTournament.noofplayers || 2);
    }

    setCurrentTeam({
      id: null,
      teamName: "",
      isqualify: false,
      logo: null,
      is_join_from_app: false,
      group: "",
      players: [],
    });
  };

  const resetTeamForm = () => {
    setCurrentTeam({
      id: null,
      teamName: "",
      isqualify: false,
      logo: null,
      group: "",
      players: [],
    });

    if (fileInputRef.current) fileInputRef.current.value = "";
    // Use the tournament's noofplayers instead of hardcoding 2
    setNoOfPlayers(tournament.noofplayers);
    updatePlayerFields(tournament.noofplayers);
  };

  const handleAddTeam = async () => {
    if (!currentTeam.teamName.trim()) {
      Common.showToast("Please enter team name", "Error");
      return;
    }

    if (!currentTeam.group.trim()) {
      Common.showToast("Please enter group", "Error");
      return;
    }

    if (
      !currentTeam.id &&
      tournament.maxTeams > 0 &&
      teams.length >= tournament.maxTeams
    ) {
      Common.showToast(
        `Cannot add more than ${tournament.maxTeams} teams`,
        "Error"
      );
      return;
    }

    const validPlayers = playerFields.filter((p) => p.playerId);
    if (validPlayers.length < noOfPlayers) {
      Common.showToast(
        "Please add all players with valid phone numbers",
        "Error"
      );
      return;
    }

    let logoPath=currentTeam.logo;
    if (currentTeam.logo instanceof File) {
      var image = (
        await Common.Utility.handleFileUpload(
          [currentTeam.logo],
          ImageFolderEnum.trmt_logo
        )
      )[0].photo;
      currentTeam.logo = image;
      logoPath = image;
    } else if (!currentTeam.logo) {
       currentTeam.logo = null;
       logoPath = null;
    }
    else{
      logoPath=currentTeam.logo
    }
    
    const newTeam = {
      id: currentTeam.id || `temp-${Date.now()}`,
      teamName: currentTeam.teamName,
      isqualify: currentTeam.isqualify,
      logo: logoPath,
      is_join_from_app: currentTeam.is_join_from_app,
      group: currentTeam.group || "",
      players: playerFields.map((player) => ({
        playerId: player.playerId,
        firstName: player.firstName,
        lastName: player.lastName,
        phone: player.phone || "",
      })),
    };

    if (typeof currentTeam.id === "number" && currentTeam.id > 0) 
    {
      setTeams((prev) =>
        prev.map((team) =>
          team.id === currentTeam.id ? newTeam : team
        )
      );
    } else if (
      typeof currentTeam.id === "string" && currentTeam.id.startsWith("temp-")
    ) {
      setTeams((prev) =>
        prev.map((team) =>
          team.id === currentTeam.id ? newTeam : team
        )
      );
    } else {
      setTeams((prev) => [...prev, newTeam]);
    }
        setCurrentTeam(null); 
        setRecord(true);

        resetTeamForm();
      };

  // const handleRemoveTeam = (teamId) => {
  //   setTeams(teams.filter((team) => team.id !== teamId));

  // };

  const handleRemoveTeam = (teamId) => {
    setTeams((prevTeams) => {
      const updatedTeams = prevTeams.filter((team) => team.id !== teamId);

      if (updatedTeams.length !== prevTeams.length) {
        setRecord(true);
      }

      return updatedTeams;
    });
  };

  const handleEditTeam = (team) => {


    // let dummyTeamId=team.id ++;
    // if(team.id==0){
    //   setCurrentTeam(dummyTeamId);
    // }


    
    window.scrollTo({
    top: 0, 
    behavior: "smooth",
  });
    setCurrentTeam({
      id: team.id,
      teamName: team.teamName,
      isqualify: team.isqualify,
      is_join_from_app: team.is_join_from_app,
      logo: team.logo || null,
      group: team.group || "",
      players: team.players,
    });

    setNoOfPlayers(team.players.length);

    const fields = team.players.map((player, index) => ({
      index,
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      phone: player.phone || "",
    }));

    setPlayerFields(fields);
  };

  const saveTeams = async () => {
    if (!tournamentId) {
      Common.showToast("Please select a tournament", "Error");
      return;
    }

    if (teams.length === 0 && !record) {
      Common.showToast("Please add at least one team", "Error");
      return;
    }

    setSaveBtnDisabled(true);

    try {
      const data = {
        tournamentId: tournamentId,
        teams: teams.map((team) => ({
          id: typeof team.id === "number" ? team.id : 0,
          teamName: team.teamName,
          isQualified: team.isqualify,
          group: team.group || "",
          logo: team.logo || null,
          played: 0,
          wins: 0,
          lose: 0,
          draw: 0,
          points: 0,
          isApproved: true,
          pct: 0,
          pf: 0,
          pa: 0,
          pd: 0,
          tournamentId: tournamentId,
          transactionLogId: null,
          players: team.players.map((player) => ({
            playerId: player.playerId,
          })),
        })),
      };

      const response = await Common.ApiService.getInstance().request(
        "AddUpdateTournamentTeams",
        data,
        "POST"
      );

      if (response.status === respEnum.Success) {
        setRecord(false);
        Common.SweetAlert.alert(response.message || "Teams saved successfully");
        resetTeamForm();
        // setTimeout(() => {
          setTeams([]);   
        await getTournamentTeamDetails(tournamentId); 
        // }, 300);
      } else {
        Common.showToast(response.message || "Error saving teams");
      }
    } catch (error) {
      console.error("Error saving teams:", error);
      Common.showToast("Error saving teams");
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  const sortedTeams = [...teams].sort((a, b) => {
    if (a.group < b.group) return -1;
    if (a.group > b.group) return 1;
    return 0;
  });

  return (
    <div>
      <style>
        {`
          .hover\\:text-primary-foreground:hover {
            --tw-text-opacity: 1 !important;
            color: grey !important;
          }
        `}
      </style>

      <div className="space-y-6 mb-3">
        <Card
          title="Tournament Teaming"
          className="shadow-md border-t-4 border-t-blue-500 overflow-hidden"
        >
          <div className="md:grid md:grid-cols-3 gap-6">
            <div className="flex flex-col col-span-3">
              <div className="md:grid md:grid-cols-3 gap-6 mt-6">
                <div className="flex flex-col col-span-3">
                  <div className="md:grid md:grid-cols-2 gap-6 space-y-6 md:space-y-0">
                    <div className="flex flex-col col-span-5 gap-2">
                      <div className="flex flex-col w-full">
                        <div
                          className="flex-1"
                          style={{
                            flexBasis: "33.33%",
                            maxWidth: "316.64px",
                            paddingLeft: "40px",
                          }}
                        >
                          {/* Ultra-compact single line header */}
                          <div className="mt-6">
                            <div className="flex items-center justify-between">
                              <div className="flex flex-col sm:flex-row sm:items-end space-y-2 sm:space-y-0 sm:space-x-4 pb-2 w-full">
                                <div className="min-w-[250px] flex-shrink-0">
                                  <label className="block text-sm font-medium mb-1 text-[#0C1B3A]">
                                    Tournament
                                  </label>
                                  <AppSearchSelect
                                    data={tournaments?.map((item) => ({
                                      id: item.id,
                                      name: item.name,
                                    }))}
                                    placeholder="Select Tournament"
                                    value={tournamentId}
                                    onChange={changeTournament}
                                  />
                                </div>

                                {isDropdownEnabled && (
                                  <div className="flex space-x-2 flex-shrink-0">
                                    <div className="bg-[#0C1B3A] text-white rounded-md px-3 py-2 h-[38px] flex items-center">
                                      <span className="text-white font-medium text-sm whitespace-nowrap">
                                        Teams:{" "}
                                        <span className="font-bold">
                                          {teams.length}/
                                          {tournament.maxTeams || 0}
                                        </span>
                                      </span>
                                    </div>

                                    <div className="bg-[#0C1B3A] text-white rounded-md px-3 py-2 h-[38px] flex items-center">
                                      <span className="text-white font-medium text-sm whitespace-nowrap">
                                        Players/Team:{" "}
                                        <span className="font-bold">
                                          {tournament.noofplayers}
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Team Management Box */}
              {isDropdownEnabled && (
                <div className="mt-6 px-6 md:px-10">
                  <div className="bg-white rounded-lg border shadow-sm overflow-hidden mb-6">
                    <div className="bg-[#0C1B3A] p-4">
                      <h3 className="text-lg font-semibold text-white">Team</h3>
                    </div>

                    {/* Team Details Section */}
                    <div className="p-6 border-b">
                      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                          <label className="block text-sm font-medium mb-1 text-[#0C1B3A]">
                            Team Name
                          </label>
                          <AppInput
                            value={currentTeam.teamName}
                            placeholder="Team Name"
                            onChange={(value) =>
                              setCurrentTeam({
                                ...currentTeam,
                                teamName: value,
                              })
                            }
                          />
                        </div>

                        <div className="md:col-span-2">
                          <label className="block text-sm font-medium mb-1 text-[#0C1B3A]">
                            Group
                          </label>
                          <AppInput
                            value={currentTeam.group}
                            placeholder="Group"
                            onChange={(value) =>
                              setCurrentTeam({ ...currentTeam, group: value })
                            }
                          />
                        </div>

                        <div className="md:col-span-1 ">
                          <label className="block text-sm font-medium mb-1 text-[#0C1B3A] whitespace-nowrap" >
                            Is Qualified
                          </label>
                          <AppSwitch
                            value={currentTeam.isqualify}
                            onChange={() =>
                              setCurrentTeam({
                                ...currentTeam,
                                isqualify: !currentTeam.isqualify,
                              })
                            }
                          />
                        </div>

                        <div className="md:col-span-2">
                          <div className="flex items-center space-x-4">
                            <div className="flex-shrink-0 w-24">
                              <label className="block text-sm font-medium mb-1 text-[#0C1B3A]">
                                Select Logo
                              </label>
                              <div className="w-100 h-20 relative">
                              {currentTeam.logo ? (
                                <div className="relative w-full h-full">
                                  <img
                                    src={
                                      typeof currentTeam.logo === "string"
                                        ? Common.Utility.getImagePath(
                                            currentTeam.logo
                                          )
                                        : URL.createObjectURL(currentTeam.logo)
                                    }
                                    alt="Team Logo"
                                    className="w-full h-full object-cover rounded"
                                  />

                                  <div className="absolute top-1 right-1 flex space-x-1">
                                    <label className="bg-white rounded-full p-1 cursor-pointer shadow">
                                      <Edit2 className="w-4 h-4 text-gray-700" />
                                      <Input
                                        type="file"
                                        className="hidden"
                                        onChange={(e) => {
                                          const file = e.target.files?.[0];
                                          if (file) {
                                            setCurrentTeam({
                                              ...currentTeam,
                                              logo: file,
                                            });
                                          }
                                        }}
                                      />
                                    </label>

                                    <button
                                      type="button"
                                      className="bg-red-100 rounded-full p-1 shadow"
                                      onClick={() =>
                                        setCurrentTeam({
                                          ...currentTeam,
                                          logo: null,
                                        })
                                      }
                                    >
                                      <span className="text-red-500 text-xs">
                                        X
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <label className="flex flex-col items-center justify-center   rounded cursor-pointer ">
                                  <ImagePlus className="w-6 h-6 text-gray-400" />
                                  {/* <span className="text-gray-500 text-xs mt-1">
                                    Choose Logo
                                  </span> */}
                                  <Input
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => {
                                      const file = e.target.files?.[0];
                                      if (file) {
                                        setCurrentTeam({
                                          ...currentTeam,
                                          logo: file,
                                        });
                                      }
                                    }}
                                  />
                                </label>
                              )}
                            </div>
                              
                            </div>

                            {/* <div className="w-100 h-20 relative">
                              {currentTeam.logo ? (
                                <div className="relative w-full h-full">
                                  <img
                                    src={
                                      typeof currentTeam.logo === "string"
                                        ? Common.Utility.getImagePath(
                                            currentTeam.logo
                                          )
                                        : URL.createObjectURL(currentTeam.logo)
                                    }
                                    alt="Team Logo"
                                    className="w-full h-full object-cover rounded"
                                  />

                                  <div className="absolute top-1 right-1 flex space-x-1">
                                    <label className="bg-white rounded-full p-1 cursor-pointer shadow">
                                      <Edit2 className="w-4 h-4 text-gray-700" />
                                      <Input
                                        type="file"
                                        className="hidden"
                                        onChange={(e) => {
                                          const file = e.target.files?.[0];
                                          if (file) {
                                            setCurrentTeam({
                                              ...currentTeam,
                                              logo: file,
                                            });
                                          }
                                        }}
                                      />
                                    </label>

                                    <button
                                      type="button"
                                      className="bg-red-100 rounded-full p-1 shadow"
                                      onClick={() =>
                                        setCurrentTeam({
                                          ...currentTeam,
                                          logo: null,
                                        })
                                      }
                                    >
                                      <span className="text-red-500 text-xs">
                                        X
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <label className="flex flex-col items-center justify-center w-full h-full border border-dashed border-gray-300 rounded cursor-pointer hover:border-gray-400">
                                  <ImagePlus className="w-6 h-6 text-gray-400" />
                                  <span className="text-gray-500 text-xs mt-1">
                                    Choose Logo
                                  </span>
                                  <Input
                                    type="file"
                                    className="hidden"
                                    onChange={(e) => {
                                      const file = e.target.files?.[0];
                                      if (file) {
                                        setCurrentTeam({
                                          ...currentTeam,
                                          logo: file,
                                        });
                                      }
                                    }}
                                  />
                                </label>
                              )}
                            </div> */}
                          </div>
                        </div>

                        <div className="md:col-span-2 flex">
                          <Button
                            onClick={handleAddTeam}
                            className="w-full bg-[#0C1B3A] hover:bg-[#0C1B3A]/90 transition-colors"
                          >
                            {currentTeam.id ? "Update Team" : "Add Team"}
                          </Button>
                        </div>

                        {/* Right to Add btn */}
                        {/* <div className="md:col-span-2 flex items-end">
                          <Button
                            onClick={saveTeams}
                            disabled={saveBtnDisabled}
                            className="bg-[#0C1B3A] hover:bg-[#0C1B3A]/90 transition-colors px-6"
                          >
                            {saveBtnDisabled ? (
                              <div className="flex items-center">
                                <svg
                                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                                Saving...
                              </div>
                            ) : (
                              "Save Teams"
                            )}
                          </Button>
                        </div> */}
                      </div>
                    </div>

                    {/* Team Players Section */}
                    <div>
                      <div className="bg-gray-100 px-6 py-3 border-b">
                        <h4 className="font-medium text-[#0C1B3A]">
                          Team Players
                        </h4>
                      </div>

                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead>
                            <tr className="bg-gray-50">
                              <th className="text-left py-3 px-6 font-medium text-[#0C1B3A] md:w-64 w-20">
                                Phone Number
                              </th>
                              <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                                First Name
                              </th>
                              <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                                Last Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {playerFields.map((field, index) => (
                              <tr
                                key={index}
                                className="border-b last:border-b-0 hover:bg-gray-50 transition-colors px-10"
                              >
                                <td className="py-3 px-10">
                                  <div className="flex items-center space-x-2">
                                    <div className="flex-1 w-[200px] ">
                                     <AppInput
                                        value={field.phone}
                                        placeholder="Enter Phone Number"
                                        onChange={(value) => {
                                          const updatedFields = [...playerFields];
                                          updatedFields[index].phone = value;
                                          setPlayerFields(updatedFields);
                                        }}
                                        onKeyDown={ (e) => {
                                          if (e.key === "Enter") {
                                            e.preventDefault();
                                             checkUserExist(field.phone, index);
                                          }
                                        }}
                                      />
                                    </div>
                                    <Button
                                      type="button"
                                      variant="ghost"
                                      className="p-1 h-8 w-8 flex-shrink-0 hover:bg-[#0C1B3A]/10 rounded-full"
                                      onClick={() => {
                                        if (
                                          !field.phone ||
                                          field.phone.length < 8 ||
                                          field.phone.length > 14
                                        ) {
                                          toast.error(
                                            `Correct Number is Required`
                                          );
                                          return;
                                        }
                                        checkUserExist(field.phone, index);
                                      }}
                                    >
                                      <FaSearch className="text-[#0C1B3A]" />
                                    </Button>
                                  </div>
                                </td>
                                <td className="py-3 px-10 w-[200px] ">
                                  <AppInput
                                    value={field.firstName}
                                    placeholder="First Name"
                                    disabled={true}
                                    className="w-[200px] "
                                  />
                                </td>
                                <td className="py-3 px-10 w-[200px] ">
                                  <AppInput
                                    value={field.lastName}
                                    placeholder="Last Name"
                                    disabled={true}
                                    className="w-[200px] "
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Card>

        {teams.length > 0 && (
          <div className=" mb-6">
            <Card title="Teams" className="shadow-sm border overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Sr#
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Team Name
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Is Qualified
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Join From App
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Team Logo
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Group
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        No of Players
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Players
                      </th>
                      <th className="text-left py-3 px-6 font-medium text-[#0C1B3A]">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedTeams.map((team, index) => (
                      <tr
                        key={`team-${team.id}`}
                        className="border-b last:border-b-0 hover:bg-gray-50 transition-colors"
                      >
                        <td className="py-3 px-6">{index + 1}</td>

                        <td className="py-3 px-6 font-medium">
                          {team.teamName}
                        </td>

                        <td className="py-3 px-6">
                          {team.isqualify ? "Yes" : "No"}
                        </td>

                        {/* <td className="py-3 px-6">
                          <AppSwitch value={team.isqualify} />
                        </td> */}

                        <td className="py-3 px-6">
                          {team.is_join_from_app ? "Yes" : "No"}
                        </td>
                        <td className="py-3 px-6">
                          {team.logo ? (
                            <img
                              src={Common.Utility.getImagePath(team.logo)}
                              alt="Team Logo"
                              className="w-12 h-12 object-cover rounded"
                            />
                          ) : (
                            <span>-</span>
                          )}
                        </td>

                        <td className="py-3 px-6">
                          <span className="bg-gray-100 px-2 py-1 rounded-md text-sm">
                            {team.group??"-"}
                          </span>
                        </td>

                        <td className="py-3 px-6">{team.players.length}</td>

                        <td className="py-3 px-6">
                          {team.players.map((player, pidx) => (
                            <div
                              key={pidx}
                              className="py-1 border-b last:border-b-0 border-gray-100"
                            >
                              <span className="font-medium">
                                {player.firstName} {player.lastName}
                              </span>
                              {player.phone && (
                                <span className="text-gray-500 ml-2 text-sm">
                                  ({player.phone})
                                </span>
                              )}
                            </div>
                          ))}
                        </td>
                        <td className="py-3 px-6">
                          <div className="flex items-center space-x-2">
                            <Button
                              variant="ghost"
                              className="p-1 h-8 w-8 hover:bg-[#0C1B3A]/10 rounded-full"
                              onClick={() => handleEditTeam(team)}
                            >
                              <FaEdit className="text-[#0C1B3A]" />
                            </Button>

                            {!team.is_join_from_app && (
                              <Button
                                variant="ghost"
                                className="p-1 h-8 w-8 hover:bg-red-50 rounded-full"
                                onClick={() => handleRemoveTeam(team.id)}
                              >
                                <FaTrash className="text-red-500" />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* <div className="flex justify-end p-4 bg-gray-50 border-t">
                <Button
                  onClick={saveTeams}
                  disabled={saveBtnDisabled}
                  className="bg-[#0C1B3A] hover:bg-[#0C1B3A]/90 transition-colors px-6"
                >
                  {saveBtnDisabled ? (
                    <div className="flex items-center">
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Saving...
                    </div>
                  ) : (
                    "Save Teams"
                  )}
                </Button>   
              </div> */}
            </Card>
          </div>
        )}

        {/* outside table btn */}
        {record && (
          <div className="flex justify-end p-4 bg-gray-50 border-t">
            <Button
              onClick={saveTeams}
              disabled={saveBtnDisabled}
              className="bg-[#0C1B3A] hover:bg-[#0C1B3A]/90 transition-colors px-6"
            >
              {saveBtnDisabled ? (
                <div className="flex items-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Saving...
                </div>
              ) : (
                "Save Teams"
              )}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
